import React from 'react'
import './PromotionalBannerQueryListComponent.css'

const PromotionalBannerQueryListComponent = () => {
    return (
        <div className="banner_section" style={{ flex: "1" }}>
            <div className="container" ><div className="row" ><div className="col-lg-12 mb_commn_pd_0" ><div className="promotional_banner_section" ><div className="row" ><div ><h6 >Total Queries : 0</h6></div>

                <div className="table-responsive custom-table-01" ><table className="table table-striped" ><thead ><tr ><th >S.No</th>
                    <th >Banner</th>
                    <th >Name</th>
                    <th >UserEmail</th>
                    <th >PhoneNumber</th>
                    <th >Query</th>
                    <th >Date</th></tr></thead></table></div></div></div></div></div></div>
        </div>
    )
}

export default PromotionalBannerQueryListComponent
